(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '@material-ui/core/styles', '@material-ui/core/Tooltip', '../../styles', '../../elements/typography'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('@material-ui/core/styles'), require('@material-ui/core/Tooltip'), require('../../styles'), require('../../elements/typography'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.styles, global.Tooltip, global.styles, global.typography);
    global.Tooltip = mod.exports;
  }
})(this, function (exports, _react, _styles, _Tooltip, _styles2, _typography) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React = _interopRequireWildcard(_react);

  var _Tooltip2 = _interopRequireDefault(_Tooltip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var styles = {
    tooltip: {
      backgroundColor: _styles2.colors.prussian,
      color: _styles2.colors.white,
      borderRadius: '2px',
      maxWidth: '17.25rem'
    },
    tooltipPlacementTop: {
      margin: '12px 0'
    },
    tooltipPlacementRight: {
      margin: '0 12px'
    },
    tooltipPlacementBottom: {
      margin: '12px 0'
    },
    tooltipPlacementLeft: {
      margin: '0 12px'
    },
    white: {
      color: _styles2.colors.white
    }
  };


  var CustomTooltip = function CustomTooltip(_ref) {
    var classes = _ref.classes,
        placement = _ref.placement,
        children = _ref.children,
        content = _ref.content,
        disableHoverListener = _ref.disableHoverListener;
    return React.createElement(
      _Tooltip2.default,
      {
        placement: placement,
        classes: {
          tooltip: classes.tooltip,
          tooltipPlacementTop: classes.tooltipPlacementTop,
          tooltipPlacementRight: classes.tooltipPlacementRight,
          tooltipPlacementBottom: classes.tooltipPlacementBottom,
          tooltipPlacementLeft: classes.tooltipPlacementLeft
        },
        title: React.createElement(
          _typography.Note,
          { className: classes.white },
          content
        ),
        disableHoverListener: disableHoverListener
      },
      children
    );
  };

  _Tooltip2.default.defaultProps = {
    placement: 'top',
    disableHoverListener: false
  };

  exports.default = (0, _styles.withStyles)(styles)(CustomTooltip);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tooltip/Tooltip.js
// module id = 881
// module chunks = 1